Vue.component("example-test-component", require("./Index.vue").default);
